/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Credits_All_CreditsInputs */

const en_admin_credits_all_credits = /** @type {(inputs: Admin_Credits_All_CreditsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All Credits`)
};

/**
* | output |
* | --- |
* | "All Credits" |
*
* @param {Admin_Credits_All_CreditsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_credits_all_credits = /** @type {((inputs?: Admin_Credits_All_CreditsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Credits_All_CreditsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_credits_all_credits(inputs)
});
export { admin_credits_all_credits as "admin.credits.all_credits" }